import React from 'react';
import Home from "../sections/Home";
import SATHA from "../sections/SATHA";
import VIMAL from "../sections/VIMAL";
import SANTO from "../sections/SANTO";
import Shop from "../sections/Shop";
import Banner from "../sections/Banner";
import Footer from '../sections/Footer';

// This component just holds all the sections for your main page
const HomePage = () => {
  return (
    <>
      <Home />
      <SATHA />
      <SANTO />
      <VIMAL />
      <Banner />
      <div style={{ paddingTop: "60px" }}>
        <Shop />
      </div>
      <Footer />
    </>
  );
};

export default HomePage;